<template>
  <el-tabs ref="tabs" v-model="tapActive" type="card" closable class="systerm" @tab-click="changeTab" @tab-remove="removeTab" :key="locale">
    <el-tab-pane
      v-for="item in stateData"
      :key="item.name"
      :label="specialTranslate(['systemMenu', 'menuListData'], item.name)"
      :name="item.name"
      class="gva-tab"
    />
  </el-tabs>
</template>

<script setup>
import { reactive, computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { specialTranslate } from '@/language/hooks.js'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()
const router = useRouter()
const reactiveDate = reactive({
  contextMenuVisible: false,
})
const store = useStore()
const tabs = ref()
const stateData = computed(() => store.getters.getActive)

const tapActive = computed({
  get() {
    return store.getters.getActiveIndex
  },
  set(val) {
    store.dispatch('setActiveIndex', val)
  },
})
const changeTab = value => {
  let active = stateData.value.filter(item => {
    return item.name == value.props.name
  })
  let { path, name, query } = active[0]
  router.push({ path: path, query: query })
  store.dispatch('setActiveIndex', name)
}

const emits = defineEmits(['remove'])
const removeTab = tab => {
  const findOne = stateData.value.find(item => item.name === tab)
  emits('remove', findOne.routeName)
  if (stateData.value.length <= 1) return
  // 删除标签
  store.dispatch('removeActive', tab)
  if (tapActive.value == tab) {
    const lastTab = stateData.value[stateData.value.length - 1]
    store.dispatch('setActiveIndex', lastTab.name)
    router.push({ path: lastTab.path, query: lastTab.query || {} })
  }
}
const showClosa = () => {}
const AllClosa = () => {}

watch(
  () => store.getters.getActiveSiteId,
  (oldVal, newVal) => {
    if (oldVal && newVal) {
      store.dispatch('onlySaveCurrent', tapActive.value)
    }
  },
)
</script>

<style scoped lang="scss">
.systerm {
  --el-tabs-header-height: 38px;

  :deep(.el-tabs__header) {
    margin: 0;
    border-bottom: none !important;
  }

  :deep(.el-tabs__nav-wrap) {
    margin-bottom: 0;
  }

  :deep(.el-tabs__nav) {
    border: none !important;
    border-radius: 0 !important;
  }

  :deep(.el-tabs__item) {
    height: 38px;
    line-height: 38px;
    padding: 0 16px;
    margin-right: 8px;
    font-size: 16px;
    color: var(--ui-tabs-item-color, #e3e3e3);
    border: var(--ui-tabs-item-border, none) !important;
    border-radius: var(--ui-tabs-item-radius, 4px);
    background: var(--ui-tabs-item-bg, var(--header-background-color, var(--tab-background))) !important;
    background-size: 100% 100%;
    box-shadow: var(--ui-tabs-item-shadow, none);
    transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:last-child {
      margin-right: 0;
    }

    .is-icon-close {
      color: rgba(255, 255, 255, 0.7);

      &:hover {
        color: #ffffff;
        background-color: rgba(255, 255, 255, 0.15);
      }
    }

    &.is-active {
      color: var(--ui-tabs-item-active-color, #ffd04b) !important;
      background: var(--ui-tabs-item-active-bg, var(--header-background-color, var(--tab-background))) !important;
      background-size: 100% 100%;
      box-shadow: var(--ui-tabs-item-shadow, none);
      border: var(--ui-tabs-item-active-border, none) !important;
    }
  }
}
</style>
